import "./App.css";
import React, { useState, useCallback, useEffect } from "react";
import { Canvas } from "@react-three/fiber";
import {
  GizmoHelper,
  GizmoViewcube,
  OrbitControls,
  Stats,
} from "@react-three/drei";
import { Suspense } from "react";
import Scene from "./Scene.js";
import { Button, ButtonGroup, Typography } from "@mui/material";
import OpenWithIcon from "@mui/icons-material/OpenWith";

import {
  KeyboardDoubleArrowDown,
  FileUpload,
  FileDownload,
  ExpandMore,
  ExpandLess,
  Favorite
} from "@mui/icons-material";
import CloseIcon from "@mui/icons-material/Close";
import useStore from "./Store";
import "react-var-ui/dist/index.css";

import {
  VarButton,
  VarCategory,
  VarDisplay,
  VarImage,
  VarFile,
  VarSelect,
  VarSlider,
  VarColor,
  VarUI,
} from "react-var-ui";

import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "../src/react-tabs.css";
import GetInfo from "./GetInfo";

import { ScrollMenu } from "react-horizontal-scrolling-menu";
import Card from "./Card";
import { LeftArrow, RightArrow } from "./Arrows";

function App() {
  const [textureUrl, setTextureUrl] = useState("assets/dragon.png");
  const [meshUrl, setMeshUrl] = useState(
    "assets/LeePerrySmith/LeePerrySmith.glb"
  );
  const [allMaterials, setAllMaterials] = useState([]);
  const [isDrawerOpen, setDrawerOpen] = useState(false);
  const [renderer, setRenderer] = useState("");
  const [camera, setCamera] = useState("");
  const [scene, setScene] = useState("");
  const [modelName, setModelName] = useState("glb");

  const createImageUrl = (buffer, type) => {
    const blob = new Blob([buffer], { type });
    const urlCreator = window.URL || window.webkitURL;
    const imageUrl = urlCreator.createObjectURL(blob);
    return imageUrl;
  };

  const getFile = async (file) => {
    // const file = e.target.files[0];
    const { type } = file;
    if (file.name.endsWith("glb")) {
      setModelName("glb");
    } else if (file.name.endsWith("obj")) {
      setModelName("obj");
    }
    const buffer = await file.arrayBuffer();
    const imageUrl = createImageUrl(buffer, type);
    setMeshUrl(imageUrl);
    setModelImages([...modelImages, file.name]);
    setModels([...models, imageUrl]);
  };

  const [values, setValues] = useState({
    toggle: true,
    color: "#FF0000",
    select: 1,
    slider: 0.4,
    xy: [0, 0.2],
    string: "Hello world!",
  });

  const onTextureChange = useCallback((value) => {
    console.log([...materials, value]);

    setMaterials([...materials, value]);

    setTextureUrl(value);
  }, []);

  const onLayerChange = useCallback((value) => {
    setCurrentMaterial(value);
  }, []);

  const onMeshChange = useCallback((value) => {
    getFile(value);
  }, []);

  const currentMaterial = useStore((state) => state.currentMaterial);
  const setCurrentMaterial = useStore((state) => state.setCurrentMaterial);
  const materialScale = useStore((state) => state.materialScale);
  const setMaterialScale = useStore((state) => state.setMaterialScale);
  //position
  const position = useStore((state) => state.position);
  const setPosition = useStore((state) => state.setPosition);
  const oldPosition = useStore((state) => state.oldPosition);
  const setOldPosition = useStore((state) => state.setOldPosition);
  //rotation
  const rotation = useStore((state) => state.rotation);
  const setRotation = useStore((state) => state.setRotation);
  const oldRotation = useStore((state) => state.oldRotation);
  const setOldRotation = useStore((state) => state.setOldRotation);

  const materials = useStore((state) => state.materials);
  const setMaterials = useStore((state) => state.setMaterials);

  const models = useStore((state) => state.models);
  const setModels = useStore((state) => state.setModels);
  const [modelImages, setModelImages] = useState([
    "assets/models/malehead.png",
    "assets/models/femaletorso.png",
    "assets/models/maletorso.png",
    "assets/models/woman.png",
    "assets/models/rightarm.png",
  ]);

  const [showPositionControls, setPositionControls] = useState(true);
  const [showRotationControls, setRotationControls] = useState(false);
  const [showInstructions, setShowInstructions] = useState(true);

  //color
  const color = useStore((state) => state.color);
  const setColor = useStore((state) => state.setColor);

  //Scroller
  function onWheel(apiObj, ev) {
    const isThouchpad = Math.abs(ev.deltaX) !== 0 || Math.abs(ev.deltaY) < 15;

    if (isThouchpad) {
      ev.stopPropagation();
      return;
    }

    if (ev.deltaY < 0) {
      apiObj.scrollNext();
    } else if (ev.deltaY > 0) {
      apiObj.scrollPrev();
    }
  }

  const [tabIndex, setTabIndex] = useState(0);

  const handleTextureClick = (id) => () => {
    setTextureUrl(materials[id]);
  };
  const handleMeshClick = (id) => () => {
    console.log(models[id]);
    setMeshUrl(models[id]);
    if (models[id].endsWith("glb")) {
      setModelName("glb");
    } else if (models[id].endsWith("obj")) {
      setModelName("obj");
    }
  };

  useEffect(() => {
    console.log(allMaterials[currentMaterial]);
  }, [allMaterials]);
  return (
    <>
      <Canvas
        camera={{ position: [10, 10, -10] }}
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "black",
        }}
        gl={{ preserveDrawingBuffer: false }}
      >
        <GizmoHelper alignment={"top-right"} margin={[80, 80]}>
          <GizmoViewcube labelColor={"black"} />
        </GizmoHelper>
        <ambientLight intensity={0.2} />
        <pointLight position={[10, 10, 5]} intensity={1} />
        <pointLight position={[-10, -10, -5]} intensity={0.3} />

        <Suspense fallback={null}>
          <Scene
            textureUrl={textureUrl}
            meshUrl={meshUrl}
            allMaterials={allMaterials}
            setAllMaterials={setAllMaterials}
            setRenderer={setRenderer}
            setCamera={setCamera}
            setScene={setScene}
            modelName={modelName}
          />
        </Suspense>
        <OrbitControls
          makeDefault
          // maxPolarAngle={Math.PI / 2}
          minDistance={1}
          // maxPolarAngle={Math.PI}
          // minDistance={1e-4}
          // maxDistance={1e-4}
          enablePan={false}
        />
        <Stats showPanel={0} className="stats" />
        <GetInfo />
      </Canvas>
      <ButtonGroup
        size="lg"
        fullWidth
        style={
          isDrawerOpen
            ? {
                position: "absolute",
                bottom: "0%",
                opacity: "0%",
              }
            : {
                position: "absolute",
                bottom: "0%",
                opacity: "100%",
              }
        }
      >
        <Button
          onClick={() => {
            setTabIndex(0);
            setDrawerOpen(true);
          }}
          style={{
            zIndex: 1000,
            height: "100px",
            backgroundColor: "skyblue",
            opacity: "70%",
          }}
        >
          Upload
          <FileUpload
            className="upArrow"
            size="lg"
            style={{ opacity: "100%", height: "100px" }}
          />
        </Button>
        <Button
          onClick={() => {
            setTabIndex(1);
            setDrawerOpen(true);
          }}
          style={{
            zIndex: 1000,
            height: "100px",
            backgroundColor: "skyblue",
            opacity: "70%",
          }}
        >
          Move
          <OpenWithIcon
            className="upArrow"
            style={{ opacity: "100%", height: "100px" }}
          />
        </Button>
        <Button
          onClick={() => {
            setTabIndex(2);
            setDrawerOpen(true);
          }}
          style={{
            zIndex: 1000,
            height: "100px",
            backgroundColor: "skyblue",
            opacity: "70%",
          }}
        >
          Export
          <FileDownload
            className="upArrow"
            style={{ opacity: "100%", height: "100px" }}
          />
        </Button>
      </ButtonGroup>
      {isDrawerOpen && (
        <div
          className="App"
          style={{
            position: "absolute",
            width: window.innerWidth,
            top: window.innerHeight - window.innerHeight / 3,
            maxHeight: window.innerHeight / 3,
            zIndex: 9999,
          }}
        >
          <VarUI>
            <VarCategory>
              <VarButton
                buttonLabel={<KeyboardDoubleArrowDown />}
                onClick={() => setDrawerOpen(false)}
              />
              <div style={{ gridColumn: 1 / 3, overflowY: "auto" }}>
                <Tabs
                  selectedIndex={tabIndex}
                  onSelect={(index) => setTabIndex(index)}
                  style={{
                    width: "100%",
                    height: "100%",
                    background: "#22222a",
                  }}
                >
                  <TabList>
                    <Tab style={{ width: window.innerWidth / 3 - 20 }}>
                      <FileUpload />
                    </Tab>
                    <Tab style={{ width: window.innerWidth / 3 - 20 }}>
                      <OpenWithIcon />
                    </Tab>
                    <Tab style={{ width: window.innerWidth / 3 - 20 }}>
                      <FileDownload />
                    </Tab>
                  </TabList>
                  <TabPanel>
                    <VarColor
                      label="Model Color"
                      value={color}
                      onChange={(value) => setColor(value)}
                    />
                    <ScrollMenu
                      LeftArrow={LeftArrow}
                      RightArrow={RightArrow}
                      onWheel={onWheel}
                    >
                      <div
                        style={{
                          width: "110px",
                          margin: "0 10px",
                        }}
                      >
                        <div
                          style={{
                            width: "40px",
                            position: "absolute",
                            zIndex: 1300,
                            top: "25%",
                            left: -1,
                            color: "whitesmoke",
                            backgroundColor: "#353542",
                            opacity: "70%",
                            fontSize: 13,
                          }}
                        >
                          Upload new image
                        </div>
                        <VarImage
                          value={textureUrl}
                          onChange={onTextureChange}
                        />
                      </div>
                      {materials.map((material, id) => (
                        <Card
                          itemId={id} // NOTE: itemId is required for track items
                          key={id}
                          onClick={handleTextureClick(id)}
                          selected={material === textureUrl}
                          textureUrl={materials[id]}
                        />
                      ))}
                    </ScrollMenu>
                    <ScrollMenu
                      LeftArrow={LeftArrow}
                      RightArrow={RightArrow}
                      onWheel={onWheel}
                    >
                      <div
                        style={{
                          width: "110px",
                          margin: "0 10px",
                        }}
                      >
                        <div
                          style={{
                            width: "40px",
                            position: "absolute",
                            zIndex: 1300,
                            top: "20%",
                            left: -1,
                            color: "whitesmoke",
                            backgroundColor: "#353542",
                            opacity: "70%",
                            fontSize: 13,
                          }}
                        >
                          Upload new model (.glb/gltf, .obj)
                        </div>
                        <VarFile displaysMetadata onChange={onMeshChange} />
                      </div>
                      {models.map((model, id) => (
                        <Card
                          itemId={id} // NOTE: itemId is required for track items
                          key={id}
                          onClick={handleMeshClick(id)}
                          textureUrl={modelImages[id]}
                        />
                      ))}
                    </ScrollMenu>
                  </TabPanel>
                  <TabPanel>
                    <VarSelect
                      label="Current Layer"
                      value={currentMaterial}
                      onChange={onLayerChange}
                      options={Array.from(
                        Array(allMaterials.length).keys()
                      ).map((value) => {
                        return { key: value, label: "Layer " + value };
                      })}
                    />
                    <VarSlider
                      label="Scale"
                      min={0}
                      max={1}
                      step={0.05}
                      value={materialScale}
                      onChange={(val) => {
                        setMaterialScale(val);
                      }}
                    />
                    <Button
                      fullWidth
                      style={{ color: "white" }}
                      onClick={() => {
                        setPositionControls(!showPositionControls);
                      }}
                    >
                      Position{" "}
                      {showPositionControls ? <ExpandMore /> : <ExpandLess />}
                    </Button>
                    {showPositionControls && (
                      <>
                        <VarSlider
                          label="X"
                          min={-15}
                          max={15}
                          step={0.1}
                          value={position[0] ?? 0}
                          onChange={(val) => {
                            if (oldPosition !== position) {
                              setOldPosition(position);
                              setPosition([val, position[1], position[2]]);
                            }
                          }}
                        />
                        <VarSlider
                          label="Y"
                          min={-15}
                          max={15}
                          step={0.1}
                          value={position[1] ?? 0}
                          onChange={(val) => {
                            if (oldPosition !== position) {
                              setOldPosition(position);
                              setPosition([position[0], val, position[2]]);
                            }
                          }}
                        />
                        <VarSlider
                          label="Z"
                          min={-15}
                          max={15}
                          step={0.1}
                          value={position[2] ?? 0}
                          onChange={(val) => {
                            if (oldPosition !== position) {
                              setOldPosition(position);
                              setPosition([position[0], position[1], val]);
                            }
                          }}
                        />
                      </>
                    )}
                    <Button
                      fullWidth
                      style={{ color: "white" }}
                      onClick={() => {
                        setRotationControls(!showRotationControls);
                      }}
                    >
                      Rotation{" "}
                      {showRotationControls ? <ExpandMore /> : <ExpandLess />}
                    </Button>
                    {showRotationControls && (
                      <>
                        <VarSlider
                          label="X"
                          min={-15}
                          max={15}
                          step={0.1}
                          value={rotation[0] ?? 0}
                          onChange={(val) => {
                            if (oldRotation !== rotation) {
                              setOldRotation(rotation);
                              setRotation([val, rotation[1], rotation[2]]);
                            }
                          }}
                        />
                        <VarSlider
                          label="Y"
                          min={-15}
                          max={15}
                          step={0.1}
                          value={rotation[1] ?? 0}
                          onChange={(val) => {
                            if (oldRotation !== rotation) {
                              setOldRotation(rotation);
                              setRotation([rotation[0], val, rotation[2]]);
                            }
                          }}
                        />
                        <VarSlider
                          label="Z"
                          min={-15}
                          max={15}
                          step={0.1}
                          value={rotation[2] ?? 0}
                          onChange={(val) => {
                            if (oldRotation !== rotation) {
                              setOldRotation(rotation);
                              setRotation([rotation[0], rotation[1], val]);
                            }
                          }}
                        />
                      </>
                    )}
                  </TabPanel>
                  <TabPanel>
                    <Button
                      variant="contained"
                      fullWidth
                      style={{
                        height: "5rem",
                        margin: "0px 5px",
                        backgroundColor: "#353542",
                      }}
                      onClick={() => {
                        renderer.render(scene, camera);
                        renderer.toneMappingExposure = 0.6;

                        renderer.domElement.toBlob(
                          function (blob) {
                            var a = document.createElement("a");
                            var url = URL.createObjectURL(blob);
                            a.href = url;
                            a.download = "canvas.jpg";
                            a.click();
                          },
                          "image/jpg",
                          1.0
                        );
                      }}
                    >
                      Export to .jpg
                    </Button>
                    <Typography style={{paddingTop: '10px', textAlign: 'center', color: 'white'}}>Made with <Favorite/></Typography>
                    <Typography style={{textAlign: 'center', fontSize: '13px', color: 'white'}}>
                      by Alex Ionkov
                      <br/><br/>
                      Credits: <br/>
                      three-projected-material by @marcofugaro <br/>
                      react-var-ui by @mat-sz <br/>
                      react-three-fiber by pmndrs
                    </Typography>
                    
                  </TabPanel>
                </Tabs>
              </div>
            </VarCategory>
          </VarUI>
        </div>
      )}
      {showInstructions && (
        <div
          style={{
            position: 'fixed',
top: '50%',
left: '50%',
transform: 'translate(-50%, -50%)',
            margin: "auto",
            color: "white",
            background: "gray",
            opacity: "90%",
            width: "60%",
            borderRadius: "25px",
            padding: "10px",
            textAlign: 'left'
          }}
        >
          <li>
            Tap or click to place a design{" "}
            <Button
              style={{ float: "right", color: "white" }}
              onClick={() => {
                setShowInstructions(false);
              }}
            >
              <CloseIcon />
            </Button>
          </li>
          <li>Use the position/rotation sliders to move it around</li>
          <li>Upload your own designs and 3d models!</li>
          <li>Export a image of your placement!</li>
        </div>
      )}
      {/* <Loader /> */}
    </>
  );
}
export default App;
